export default {
  loginFailure: 'Login failure！',
  language: 'Languages',
  loginTitle: 'LEO Solar Pumping Remote Control and Monitoring System',
  company: 'Leo Pump Industry',
  ruleName1: 'Username can not be empty',
  ruleName2:
    '4-20 characters,The first letter cannot be a number, and there cannot be special characters',
  rulePwd: 'Password can not be empty',
  ruleCode1: 'Verification can not be empty',
  tipCode1: 'Verification code error',
  rulePhone1: 'Mobile phone number cannot be empty',
  rulePhone2: 'Please enter a valid mobile phone format',
  ruleCode2: 'Please enter six digits',
  loginByUser: 'Username Login',
  loginByPhone: 'SMS Login',
  user: 'Username',
  password: 'Password',
  checkCode: 'Code',
  rememberPwd: 'Remember password',
  login: 'Login',
  phoneNumber: 'Phone',
  SMSCode: 'SMS code',
  getCode: 'Send',
  toLogin: 'Welcome to login',
  input: 'Please enter',
  Ltd: 'Zhejiang Information Technology Co. LTD',
  Ch: '中文',
  En: 'English',
  scanningInstructions:
    'Reminder: It is recommended to open the mobile browser and scan to download the app',
  register: 'Free registration',
  reset: 'Forgot password?'
}
